import { useEffect, useState } from 'react';
import AppModal from './components/AppModal.js';
import AppWidget from './AppWidget.js';

function App({ slug, showId }: { slug?: string; showId: number }) {
    const [widgetOpen, setWidgetOpen] = useState(true);

    // This should be the top level, do subscribes to custom events
    useEffect(() => {
        if (!slug) {
            const open = () => {
                setWidgetOpen(true);
            };
            const close = () => {
                // TODO: in some cases, this needs to be a navigation
                setWidgetOpen(false);
            };
            //fireknife-open-widget
            document.addEventListener('fireknife-open-widget', open);
            document.addEventListener('fireknife-close-widget', close);
            return () => {
                document.removeEventListener('fireknife-open-widget', open);
                document.removeEventListener('fireknife-close-widget', close);
            };
        }
    }, [setWidgetOpen]);

    if (!widgetOpen) {
        return null;
    }

    return (
        <AppModal widgetOpen={widgetOpen} setWidgetOpen={setWidgetOpen}>
            <AppWidget showId={showId} setWidgetOpen={setWidgetOpen} slug={slug} />
        </AppModal>
    );
}

export default App;
